import { call, put, takeEvery } from "redux-saga/effects";
import { settingsRequest } from "../../api/settings";
import { settingsActions } from "../../store/settings/actions";
import { SETTINGS_REQUEST } from "../../constants/settings";

function* settingsRequestSaga() {
  try {
    const { settings } = yield call(settingsRequest);
    yield put(settingsActions.settingsSuccessAction(settings));
  } catch (e: any) {
    yield put(settingsActions.settingsFailureAction(e));
  }
}
function* settingsSaga() {
  yield takeEvery(SETTINGS_REQUEST, settingsRequestSaga);
}

export default settingsSaga;
